export default "__VITE_ASSET__6e877dda__"